import type { PageScrollValues } from "tracking";

export const PAGE_SCROLL_PAGE_WHITELIST = [
  "/join-beauty-pie",
  "/bp/join-beauty-pie",
  "/bp/join/join-beauty-pie",
  "/bp/about/how-it-works",
  "/products"
];

export const TRACK_SCROLL_PERCENTAGES: PageScrollValues[] = [25, 50, 75, 100];
